import React from "react";
import PropTypes from "prop-types";

import ErrorMsg from "../Error";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      // eslint-disable-next-line react/no-unused-state
      error: undefined,
    };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error: error };
  }

  componentDidCatch(error, errorInfo) {
    console.error(error, errorInfo);
  }

  render() {
    const { message, children } = this.props;

    if (this.state.hasError) {
      return <ErrorMsg message={message} title="Error On Page" />;
    }

    return children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.any,
  message: PropTypes.string,
};

ErrorBoundary.defaultProps = {
  message: "Something went wrong.",
};

export default ErrorBoundary;
